<template>
  <div :id="!$route.path.includes('landing') && !isNewSite ? 'app' : ''" >


    <div v-if="$root.isLoading" class="loading">
      <div class="loading-box">

        <div class="loading-effect" style="top: 50%;left: 50%;">
          <div class="icon-button" :style="{ 'background-image': 'url(' + logo + ')' }"
            style="height: 3rem;width: auto;">
          </div>
        </div>
        <div class="loading-effect">
          <b-spinner style="width: 5rem; height: 5rem;" label="Large Spinner">

          </b-spinner>

        </div>
        <div class="loading-effect" style="top: 80%;">
          {{ $t('loading...') }}

        </div>
      </div>
    </div>
    <Header v-if="!isNewSite"></Header>
    <router-view></router-view>
    <Footer v-if="!isNewSite"></Footer>
    <!-- new site: bottom tab bar on phones/tablets (not over the full-screen Live player,
         and not on the one-screen account pages: sign in, forgot password) -->
    <NsTabBar v-if="showTabBar"></NsTabBar>
    <ModalError></ModalError>
    <!-- <Footer></Footer> -->
    <b-modal id="modal-news" hide-footer hide-header centered>
      <carousel :items="1" v-if="$root.latestNews.length > 0" :nav="false" :autoplay="true" :dots="true"
        :stagePadding="0" :margin="10">

        <div class="mb-4" v-for="item in $root.latestNews" :key="item.id">
          <div class="d-flex justify-content-between align-items-center mb-4">
            <div class="text-20 font-weight-700 text-primary2">{{ item.title }}</div>
            <span class="ml-2 text-20" @click="$bvModal.hide('modal-news')"><i class="fa fa-close"></i></span>

          </div>
          <div class="content">
            <img :src="item.public_path" alt="" width="100%" class="rounded-1">
            <div class="text-left mt-3">
              <div class="text-secondary text-12 mb-2">{{ item.updated_at.split(' ')[0] }}</div>
              <div class="mb-1 text-14 " v-html="item.description.replace(/(\r\n|\r|\n)/g, '<br>')"></div>

            </div>

          </div>

        </div>
      </carousel>
      <div class="checkbox1">
        <b-form-checkbox id="checkbox-1" class="text-14" v-model="checkBoxStatus" name="checkbox-1" :value="true"
          :unchecked-value="false" required>
          {{ $t('dont_show_again_today') }}
        </b-form-checkbox>
      </div>


    </b-modal>



    <!-- <customizer></customizer> -->
  </div>
</template>


<script>
import { mapGetters } from "vuex";
import ModalError from './errorMsg.vue';
import carousel from 'vue-owl-carousel';
import Header from './header.vue';
import Footer from './footer.vue';
import NsTabBar from './views/newsite/components/NsTabBar.vue';

export default {
  components: {
    ModalError, carousel, Header, Footer, NsTabBar
  },
  watch: {
    // The new site is a white page. metaInfo() below never runs (vue-meta is installed but
    // was never Vue.use()'d), so its "nh-page" body class never arrived and the old dark body
    // background showed through — on iPhone that is the grey Safari paints above and below
    // the page. Set it here instead, plus the browser's bar colour (theme-color).
    isNewSite: {
      immediate: true,
      handler(on) {
        document.documentElement.classList.toggle('nh-page-html', on);
        document.body.classList.toggle('nh-page', on);
        let meta = document.querySelector('meta[name="theme-color"]');
        if (!meta) {
          meta = document.createElement('meta');
          meta.setAttribute('name', 'theme-color');
          document.head.appendChild(meta);
        }
        if (!meta.dataset.oldSite) meta.dataset.oldSite = meta.getAttribute('content') || '#4DBA87';
        meta.setAttribute('content', on ? '#ffffff' : meta.dataset.oldSite);
      },
    },
    $route() {
      var title = this.$route.path.split('/');
      this.title = title[title.length - 1];
      this.path = this.title;

    },
    checkBoxStatus(val) {
      var date = new Date();
      if (val) {
        localStorage.setItem('dunShow', date.getDate());
      } else {

        localStorage.removeItem('dunShow');
      }
    }
  },
  name: 'GVV',
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["getThemeMode"]),
    // Pages of the redesigned site live under /web/new and bring their own header/footer.
    isNewSite() {
      return this.$route.path.indexOf('/web/new') === 0;
    },
    showTabBar() {
      const p = this.$route.path;
      if (!this.isNewSite) return false;
      if (p.indexOf('/web/new/live') === 0) return false;
      // checkout and its result screens have their own buttons at the bottom
      if (p === '/web/new/checkout' || p.indexOf('/web/new/order') === 0) return false;
      // the cart has its own Check Out button pinned to the bottom, where the bar would be
      return ['/web/new/login', '/web/new/forgot-password', '/web/new/sign-up', '/web/new/cart'].indexOf(p) === -1;
    },
    themeName() {
      return this.getThemeMode.dark ? "dark-theme" : " ";
    },
  },
  metaInfo() {
    var title = 'Winato';
    return {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: title.charAt(0).toUpperCase() + title.slice(1),
      // all titles will be injected into this template
      titleTemplate: "%s",
      bodyAttrs: {
        class: [this.themeName, "text-left", this.isNewSite ? "nh-page" : ""]
      },
      htmlAttrs: {
        dir: this.rtl
      },
      meta: [
        { charset: "utf-8" },
        { name: "viewport", content: "width=device-width, initial-scale=1" },
      ],
    };
  }
};
</script>

<style>
#app {
   font-family: 'Lalezar' !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  margin-top: 60px;
}


</style>


